import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import background from '../../img/background.jpg';
import { mainApiUrl } from '../../utils/consts';
import LogoComponent from '../Logo/LogoComponent';
import './styles/recoverPassword.scss';

function RecoverPasswordComponent(props) {

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [validated, setValidated] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    if (loading) setError('');
  }, [loading]);

  const handleRecoverPassword = async () => {

    const recoverPasswordProm = await fetch(`${mainApiUrl}/password_reset/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        path: 'reestablecer_contrasenia',
        businessDomain: 'cemex.'
      })
    });

    const recoverPasswordJson = await recoverPasswordProm.json();

    return recoverPasswordJson;
  };

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {
      setLoading(true);

      const resp = await handleRecoverPassword();

      if (resp.success) setEmailSent(true);
      else setError('No existen usuarios asociados al correo que has suministrado. Inténtalo de nuevo.');

      setLoading(false);
    }
  };

  return (
    <div className="recover-password-component">
      <div className="login-container" style={{ backgroundImage: `url(${background})` }}>
        <LogoComponent />
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <div className="form-container">
                {
                  emailSent ?
                  <>
                    <h1 className="app-title" style={{ fontSize: '1.75rem', textAlign: 'center' }}>
                      Te enviamos un correo electrónico para que puedas recuperar tu contraseña. Ya puedes cerrar esta ventana.
                    </h1>
                  </> :
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Row>
                      <Col xs={12}>
                        <i className="fas fa-arrow-alt-circle-left back-icon" onClick={() => props.history.push('/')} />
                      </Col>
                      <Col xs={12}>
                        <Alert variant="info">
                          Te enviaremos un correo electrónico para que puedas recuperar tu contraseña.
                        </Alert>
                      </Col>
                      <Form.Group as={Col} xs={12}>
                        <Form.Label className="app-label">Correo electrónico</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Correo"
                          value={email}
                          onChange={event => setEmail(event.target.value)}
                          required
                        />
                      </Form.Group>
                    </Form.Row>

                    <Button type="submit" disabled={loading} className="app-button">
                      {
                        loading ? <Spinner animation="border" variant="warning" size="sm" /> : 'Confirmar'
                      }
                    </Button>
                    {
                      error &&
                      <>
                        <br />
                        <Alert variant="danger">
                          { error }
                        </Alert>
                      </>
                    }
                  </Form>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default RecoverPasswordComponent;
